import React from 'react'
import { Col, Row } from 'react-bootstrap'
import ProductInfo from './ProductInfo'
import ProductAction from './ProductAction'
import { ProductThumbImage } from '@ztechapps/product.webui'

export const ProductCardLarge = ({ ...product }: any) => {
  return (
    <Row>
      <Col lg={2}>
        <ProductThumbImage url={product?.coverImage} name={product?.name} className="img-fluid" />
      </Col>
      <Col lg={7}>
        <ProductInfo {...product} />
      </Col>
      <Col lg={3}>
        <ProductAction {...product} />
      </Col>
    </Row>
  )
}
